import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type PlatformSigninFormState = {
  submitInProgress: boolean;
  lastErrorKey: string | null;
};

const initialState: PlatformSigninFormState = {
  submitInProgress: false,
  lastErrorKey: null,
};

export const platformSigninFormSlice = createSlice({
  name: 'platformSigninForm',
  initialState,
  reducers: {
    setPlatformSigninSubmitInProgress(state, action: PayloadAction<boolean>) {
      state.submitInProgress = action.payload;
    },
    setPlatformSigninLastErrorKey(state, action: PayloadAction<string | null>) {
      state.lastErrorKey = action.payload;
    },
    clearPlatformSigninForm() {
      return initialState;
    },
  },
});

export const {
  setPlatformSigninSubmitInProgress,
  setPlatformSigninLastErrorKey,
  clearPlatformSigninForm,
} = platformSigninFormSlice.actions;

export const selectPlatformSigninForm = (state: {
  platformSigninForm: PlatformSigninFormState;
}) => state.platformSigninForm;
